// import React, { useEffect, useState } from "react";
// import Header from "../Components/Header";
// import Design from "../Products/Design";
// import MoreInteresting from "../Products/MoreInteresting";
// import Footer from "../Components/Footer";
// import MenFilter from "./MenFilter";
// import { useNavigate } from "react-router-dom";
// import { useLocation } from "react-router-dom";
// import {
//   productApi,
//   productDetails,
// } from "../../Services/Operations/ProductAPI";
// import { useDispatch, useSelector } from "react-redux";
// import { get_glbFile } from "../../Services/Operations/ProductAPI";
// import { toast } from "react-toastify";
// import { FaRegHeart } from "react-icons/fa6";
// import { FaHeart } from "react-icons/fa";
// import { addFavorite, removeFavorite } from "../../Redux/Cart_System";
// import { useParams } from "react-router-dom";

// const SkeletonLoader = () => {
//   return (
//     <div className="skeleton-container">
//       <div className="page-layout-wrapper" style={{ marginTop: "78px" }}>
//         <aside className="sidebar1">
//           <div className="skeleton-filter">
//             {[...Array(5)].map((_, i) => (
//               <div key={i} className="skeleton-filter-item"></div>
//             ))}
//           </div>
//         </aside>
//         <section
//           className="main-content"
//           style={{  height: "90vh" }}
//         >
//           <div className="product-listing">
//             <div className="product-grid">
//               {[...Array(8)].map((_, i) => (
//                 <div key={i} className="skeleton-product-card">
//                   <div className="skeleton-image"></div>
//                   <div className="skeleton-text short"></div>
//                   <div className="skeleton-text medium"></div>
//                   <div className="skeleton-text long"></div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </section>
//       </div>
//       <style jsx>{`
//         .skeleton-container {
//           width: 100%;
//           padding: 20px;
//         }

//         .skeleton-filter {
//           padding: 15px;
//         }

//         .skeleton-filter-item {
//           height: 30px;
//           background: #e0e0e0;
//           margin-bottom: 10px;
//           border-radius: 4px;
//           animation: pulse 1.5s infinite ease-in-out;
//         }

//         .skeleton-product-card {
//           margin-bottom: 20px;
//           padding: 10px;
//         }

//         .skeleton-image {
//           width: 100%;
//           height: 200px;
//           background: #e0e0e0;
//           margin-bottom: 10px;
//           border-radius: 4px;
//           animation: pulse 1.5s infinite ease-in-out;
//         }

//         .skeleton-text {
//           height: 12px;
//           background: #e0e0e0;
//           margin-bottom: 8px;
//           border-radius: 4px;
//           animation: pulse 1.5s infinite ease-in-out;
//         }

//         .skeleton-text.short {
//           width: 60%;
//         }

//         .skeleton-text.medium {
//           width: 80%;
//         }

//         .skeleton-text.long {
//           width: 90%;
//         }

//         @keyframes pulse {
//           0% {
//             opacity: 0.6;
//           }
//           50% {
//             opacity: 1;
//           }
//           100% {
//             opacity: 0.6;
//           }
//         }

//         .product-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
//           gap: 20px;
//         }
//       `}</style>
//     </div>
//   );
// };

// function ProductListing() {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [mobile,setMobile]=useState(window.innerWidth <= 567?true:false);
//   const [isLoading, setIsLoading] = useState(true);
//   const [particularProduct, setParticularProduct] = useState({});
//   const { tokenDetails } = useSelector((state) => state.user);
//   const location = useLocation();
//   const { category, subcategory, menu, categoryName, subCategoryId, subCategoryName } = useParams();

//   const [productData1, setProductData] = useState([]);
//   const [categoryImage, setCategoryImage] = useState();
//   const { configUrl } = useSelector((state) => state.cart);
//   const favorites = useSelector((state) => state.cart.favorites);

//   console.log("category : ", category);
//   console.log("subcategory : ", subcategory);

//   useEffect(() => {
//     if (category && subcategory) {
//       const fetchProducts = async () => {
//         try {
//           setIsLoading(true);
//           const response = await productApi(category, subcategory);
//           console.log("productApi : ", response);
//           if (response.success) {
//             setCategoryImage(response.category_image);
//             setProductData(response.data);
//           } else {
//             setProductData([])
//           }
//         } catch (error) {
//           console.error("API Error:", error);
//         } finally {
//           setIsLoading(false);
//         }
//       };
//       fetchProducts();
//     }
//   }, [category, subcategory]);

//   const handleFavorite = (product) => {
//     const isFavorite = favorites.some((item) => item.id === product.id);
//     if (!tokenDetails) {
//       toast.error("Please login or Signup");
//       return;
//     }

//     const favoriteProduct = {
//       id: product.id,
//       menu_id: product.menu_id,
//       category_id: product.category_id,
//       subcategory_id: product.subcategory_id,
//       name: product.name,
//       slug: product.slug,
//       image: product.image,
//       menu_name: product.menu_name,
//       menu_slug: product.menu_slug,
//       category_name: product.category_name,
//       category_slug: product.category_slug,
//       subcategory_name: product.subcategory_name,
//       subcategory_slug: product.subcategory_slug,
//       size: product.size.find((size) => size.size_id),
//     };

//     console.log("favoriteProduct : ", favoriteProduct);

//     if (isFavorite) {
//       dispatch(removeFavorite(product.id));
//     } else {
//       dispatch(addFavorite(favoriteProduct));
//     }
//   };
//   console.log("configUrl : ", configUrl);

//   console.log("Product Data:", productData1);
//   console.log("Category Name:", categoryName);

//   useEffect(() => {
//     const loadData = async () => {
//       try {
//         setProductData(productData1);

//         const imageUrls = productData1
//           .flatMap((product) => [
//             product?.image,
//             configUrl + product?.second_image,
//           ])
//           .filter(Boolean);

//         let loadedCount = 0;

//         const checkAllImagesLoaded = () => {
//           loadedCount++;
//           if (loadedCount === imageUrls.length) {
//           }
//         };

//         imageUrls.forEach((url) => {
//           const img = new Image();
//           img.onload = checkAllImagesLoaded;
//           img.onerror = checkAllImagesLoaded;
//           img.src = url;
//         });

//       } catch (error) {
//         console.error("Error loading product data:", error);
//       }
//     };

//     loadData();
//   }, [productData1, configUrl]);

//     const clickProductDetailsHandler = async (name) => { 
//    navigate(`/detailsPage/${name}`);

//   };

//   if (isLoading) {
//     return <SkeletonLoader />;
//   }

//   const handleButtonClick = async (e) => {
//     e.preventDefault();

//     console.log("subcategoryId : ",subCategoryId)
//     if (!tokenDetails) {
//       toast.error("Please login or Signup");
//       return;
//     }
//     try {
//       const formData = new FormData();

//       formData.append("subcategoryId",subCategoryId);

//       const result = await get_glbFile(formData);
//       console.log("GLB Data:", result);

//       if (result.success && result.data) {
//         navigate("/3d-product", {
//           state: {
//             menuSlug: category,
//             subcategorySlug: subcategory,
//             glbFile: result.data,
//           },
//         });
//       } else {
//         toast.error("No 3D model available. Please try another product.");
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       toast.error("Something went wrong. Please try again later.");
//     }
//   };

//   return (
//     <div>
//       <body className="body-container default is-ctl-shield-listing-with-seo-box is-ctl-product_list is-ctl- is-act-">


//         <main className="content-main" style={{ backgroundColor: "white",marginTop:"100px",height:"100%" }}>


//             {mobile && 
//             <div className="" 
//             style={{maxHeight:"fit-content",minHeight:"fit-content",height:"100%",overflowY:"auto",display:"flex",flexWrap:"wrap"}}>
//                       {productData1 && productData1.length > 0 ? (
//                         productData1?.map((product) => {
//                           const isFavorite = favorites.some(
//                             (item) => item.id === product.id
//                           );
//                           const discount = product?.size[0]?.discount_percent;
//                           console.log("discount : ", discount);
//                           return (
//                             <div
//                               key={product?.id}
//                               className="product-card"
//                               style={{ position: "relative",minWidth:"150px",maxWidth:"200px"}}
//                             >
//                               <div className="product-box">
//                                 {/* {discount > 0 && (
//                                   <div
//                                     className="discount-badge pulse-animation"

//                                   >
//                                     <span style={{ fontSize: "14px" }}>
//                                       {discount}% OFF
//                                     </span>
//                                   </div>
//                                 )} */}
//                                 <span
//                                   onClick={() => handleFavorite(product)}
//                                   style={{
//                                     padding: "5px 10px",
//                                     position: "absolute",
//                                     top: "10px",
//                                     right: "10px",
//                                     borderRadius: "20px",
//                                     fontSize: "0.9rem",
//                                     zIndex: "2",


//                                   }}
//                                 >
//                                   {isFavorite ? (
//                                     <FaHeart color="red" />
//                                   ) : (
//                                     <FaRegHeart color="grey" />
//                                   )}
//                                 </span>
//                                 <div
//                                   className="product-image-wrapper"
//                                   onClick={(event) => {
//                                     event.preventDefault();
//                                     clickProductDetailsHandler(product?.slug);
//                                   }}
//                                 >
//                                   <a
//                                     href=" "
//                                     className="product-link1"
//                                     style={{ height: "100%" }}
//                                   >
//                                     <img
//                                       src={`${product?.image}`}
//                                       alt={product?.name}
//                                       className="product-image"
//                                       style={{
//                                         width: "140px",
//                                         maxHeight: "100%",
//                                         height: "170px",
//                                       }}
//                                     />

//                                   </a>
//                                 </div>
//                                 <div className="product-info" style={{display:"flex",flexDirection:"column",alignItems:"flex-start"}}>
//                                   <a
//                                     href={product.link}
//                                     className=""
//                                     style={{
//                                       display: "inline-block",
//                                       whiteSpace: "nowrap",
//                                       overflow: "hidden",
//                                       textOverflow: "ellipsis",
//                                       maxWidth: "97%",
//                                       verticalAlign: "middle",
//                                       fontSize: "12px",
//                                       textDecoration:"none",
//                                       marginBottom:"5px"
//                                     }}
//                                   >
//                                     <span
//                                       onClick={(event) => {
//                                         event.preventDefault();
//                                         clickProductDetailsHandler(
//                                           product?.slug
//                                         );
//                                       }}
//                                     >
//                                       {product?.name}
//                                     </span>
//                                   </a>
//                                   <p style={{fontSize:"8px",textAlign:"left"}}>{product?.name}</p>

//                                   <div
//                                     style={{
//                                       display: "flex",
//                                       alignItems: "center",
//                                       gap:"10px"
//                                     }}
//                                   >
//                                     <div
//                                       className="product-price"
//                                       style={{

//                                         marginTop: "0px",
//                                         color: "black",
//                                         fontSize:"11px"

//                                       }}
//                                     >

//                                       <span>${product?.size[0]?.price}</span>
//                                     </div>
//                                     <div
//                                       className="product-mrp"
//                                       style={{ fontSize: "9px" }}
//                                     >
//                                       <span className="mrp" style={{color:"#7a7a7aff"}}>
//                                        ${product?.size[0]?.mrp}
//                                       </span>
//                                     </div>
//                                     <div style={{
//                                       fontSize:"8px",
//                                       color:"red",
//                                       backgroundColor:"pink",
//                                       borderRadius:"10px",
//                                       padding:"3px"
//                                     }}>
//                                       -{discount}%
//                                       </div>
//                                   </div>
//                                   <div>
//                                     <p
//                                     onClick={()=>navigate(`/detailsPage/${product.slug}`)}
//                                     style={{fontSize:"11px",cursor:"pointer",textAlign:"left",fontWeight:700,borderBottom:"1px solid black"}}>Shop Now</p>
//                                   </div>
//                                 </div>
//                               </div>
//                             </div>
//                           );
//                         })
//                       ) : (
//                         <div className="product-grid" style={{ height:"100%",marginLeft:"100px"}}>
//                           <h3>No Products Found</h3>

//                           {window.innerWidth <= 568?
//                           <div style={{width:"100%", height:"100%", display:"flex",alignItems:"center", justifyContent:"center"}}>
//                           <p style={{textAlign:"center", fontSize:"6vw",fontWeight:"bold"}}>
//                           COMMING SOON
//                           </p></div>
//                           :
//                           <div style={{width:"100%", height:"100%", display:"flex",alignItems:"center", justifyContent:"center"}}>
//                           <p style={{textAlign:"center", fontSize:"6vw",fontWeight:"bold"}}>
//                           COMMING SOON
//                           </p></div>}


//                         </div>
//                       )}
//                     </div>
//                     }
//           <div className="container-main">

//             { mobile && <MenFilter
//   menu={menu}
//   categoryName={categoryName}
//   setProductData={setProductData}
//   productData={productData1}  // Add this line
// />
//             }

//             <div className="page-layout">
//               <div
//                 className="page-layout-wrapper"
//                style={{height:"100%",maxHeight:"1390px",overflow:"hidden" }}
//               >
//                {!mobile && // for desktop view, same component is used for mobile but placed somewhere else
//                 <aside className="sidebar1" 
//                 style={{width:"20%",maxHeight:"500px",height:"100%",msOverflowY:"auto",minHeight:"500px"}}>
//                  <MenFilter
//   menu={menu}
//   categoryName={categoryName}
//   setProductData={setProductData}
//   productData={productData1}  // Add this line
// />
//                 </aside>
//                 }

//                 {/* height:"90vh" */}
//                 <section
//                   className="main-content"
//                   style={{ backgroundColor: "white" }}
//                 >
//                   <div className="product-listing">
//                    {!mobile && <div className="product-grid" style={{maxHeight:"fit-content",height:"100%",overflowY:"auto"}}>
//                       {productData1 && productData1.length > 0 ? (
//                         productData1?.map((product) => {
//                           const isFavorite = favorites.some(
//                             (item) => item.id === product.id
//                           );
//                           const discount = product?.size[0]?.discount_percent;
//                           console.log("discount : ", discount);
//                           return (
//                             <div
//                               key={product?.id}
//                               className="product-card"
//                               style={{ position: "relative",minWidth:"320px" }}
//                             >
//                               <div className="product-box">
//                                 {/* {discount > 0 && (
//                                   <div
//                                     className="discount-badge pulse-animation"

//                                   >
//                                     <span style={{ fontSize: "14px" }}>
//                                       {discount}% OFF
//                                     </span>
//                                   </div>
//                                 )} */}
//                                 <span
//                                   onClick={() => handleFavorite(product)}
//                                   style={{
//                                     padding: "5px 10px",
//                                     position: "absolute",
//                                     top: "10px",
//                                     right: "10px",
//                                     borderRadius: "20px",
//                                     fontSize: "0.9rem",
//                                     zIndex: "2",

//                                     fontSize: "17px",
//                                   }}
//                                 >
//                                   {isFavorite ? (
//                                     <FaHeart color="red" />
//                                   ) : (
//                                     <FaRegHeart color="grey" />
//                                   )}
//                                 </span>
//                                 <div
//                                   className="product-image-wrapper"
//                                   onClick={(event) => {
//                                     event.preventDefault();
//                                     clickProductDetailsHandler(product?.slug);
//                                   }}
//                                 >
//                                   <a
//                                     href=" "
//                                     className="product-link1"
//                                     style={{ height: "100%" }}
//                                   >
//                                     <img
//                                       src={`${product?.image}`}
//                                       alt={product?.name}
//                                       className="product-image"
//                                       style={{
//                                         width: "320px",
//                                         maxHeight: "100%",
//                                         height: "400px",
//                                       }}
//                                     />
//                                     <img
//                                       src={`${configUrl}${product?.second_image}`}
//                                       alt={product?.name}
//                                       className="hover-image"
//                                       style={{  width: "400px",
//                                         maxHeight: "100%",
//                                         height: "400px",}}
//                                     />
//                                   </a>
//                                 </div>
//                                 <div className="product-info" style={{display:"flex",flexDirection:"column",alignItems:"flex-start",justifyContent:"space-between",}}>
//                                  <div className="product-info" style={{overflow:"hidden",maxWidth:"100%"}}> 
//                                   <a
//                                     href={product.link}
//                                     className="product-name"
//                                     style={{
//                                       display: "inline-block",
//                                       whiteSpace: "nowrap",
//                                       overflow: "hidden",
//                                       textOverflow: "ellipsis",
//                                       maxWidth: "97%",
//                                       verticalAlign: "middle",
//                                       fontSize: "18px",
//                                     }}
//                                   >
//                                     <span
//                                       onClick={(event) => {
//                                         event.preventDefault();
//                                         clickProductDetailsHandler(
//                                           product?.slug
//                                         );
//                                       }}
//                                     >
//                                       {product?.name}
//                                     </span>
//                                   </a>
//                                   <p style={{fontSize:"13px",textAlign:"left",fontWeight:600,color:"gray"}}>{product?.name}</p>
//                                   <div
//                                     style={{
//                                       display: "flex",
//                                       alignItems: "center",
//                                       gap:"10px"
//                                     }}
//                                   >
//                                     <div
//                                       className="product-price"
//                                       style={{

//                                         marginTop: "0px",
//                                         color: "black",
//                                         fontSize:"16px"

//                                       }}
//                                     >

//                                       <span>${product?.size[0]?.price}</span>
//                                     </div>
//                                     <div
//                                       className="product-mrp"
//                                       style={{ fontSize: "12px" }}
//                                     >
//                                       <span className="mrp" style={{color:"#7a7a7aff"}}>
//                                        ${product?.size[0]?.mrp}
//                                       </span>
//                                     </div>
//                                     <div style={{
//                                       fontSize:"10px",
//                                       color:"red",
//                                       backgroundColor:"pink",
//                                       borderRadius:"10px",
//                                       padding:"3px"
//                                     }}>
//                                       -{discount}%
//                                       </div>
//                                   </div>
//                                   </div>

//                                     <p
//                                     onClick={()=>navigate(`/detailsPage/${product.slug}`)}
//                                     style={{fontSize:"14px",cursor:"pointer",textAlign:"left",fontWeight:700,borderBottom:"1px solid black",marginBottom:1}}>Shop Now</p>

//                                 </div>
//                               </div>
//                             </div>
//                           );
//                         })
//                       ) : (
//                         <div className="product-grid" style={{ height:"100%",marginLeft:"100px"}}>
//                           <h3>No Products Found</h3>

//                           {window.innerWidth <= 568?
//                           <div style={{width:"100%", height:"100%", display:"flex",alignItems:"center", justifyContent:"center"}}>
//                           <p style={{textAlign:"center", fontSize:"6vw",fontWeight:"bold"}}>
//                           COMMING SOON
//                           </p></div>
//                           :
//                           <div style={{width:"100%", height:"100%", display:"flex",alignItems:"center", justifyContent:"center"}}>
//                           <p style={{textAlign:"center", fontSize:"6vw",fontWeight:"bold"}}>
//                           COMMING SOON
//                           </p></div>}


//                         </div>
//                       )}
//                     </div>}




//                   </div>




//                 </section>
//               </div>
//             </div>
//           </div>

//         </main>
//         <Design />

//         <Footer />
//       </body>
//     </div>
//   );
// }

// export default ProductListing;


import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import Design from "../Products/Design";
import MoreInteresting from "../Products/MoreInteresting";
import Footer from "../Components/Footer";
import MenFilter from "./MenFilter";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import {
  productApi,
  productDetails,
} from "../../Services/Operations/ProductAPI";
import { useDispatch, useSelector } from "react-redux";
import { get_glbFile } from "../../Services/Operations/ProductAPI";
import { toast } from "react-toastify";
import { FaRegHeart } from "react-icons/fa6";
import { FaHeart } from "react-icons/fa";
import { addFavorite, removeFavorite } from "../../Redux/Cart_System";
import { useParams } from "react-router-dom";

const SkeletonLoader = () => {
  return (
    <div className="skeleton-container">
      <div className="page-layout-wrapper" style={{ marginTop: "78px" }}>
        <aside className="sidebar1">
          <div className="skeleton-filter">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="skeleton-filter-item"></div>
            ))}
          </div>
        </aside>
        <section
          className="main-content"
          style={{ height: "90vh" }}
        >
          <div className="product-listing">
            <div className="product-grid">
              {[...Array(8)].map((_, i) => (
                <div key={i} className="skeleton-product-card">
                  <div className="skeleton-image"></div>
                  <div className="skeleton-text short"></div>
                  <div className="skeleton-text medium"></div>
                  <div className="skeleton-text long"></div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
      <style jsx>{`
        .skeleton-container {
          width: 100%;
          padding: 20px;
        }

        .skeleton-filter {
          padding: 15px;
        }

        .skeleton-filter-item {
          height: 30px;
          background: #e0e0e0;
          margin-bottom: 10px;
          border-radius: 4px;
          animation: pulse 1.5s infinite ease-in-out;
        }

        .skeleton-product-card {
          margin-bottom: 20px;
          padding: 10px;
        }

        .skeleton-image {
          width: 100%;
          height: 200px;
          background: #e0e0e0;
          margin-bottom: 10px;
          border-radius: 4px;
          animation: pulse 1.5s infinite ease-in-out;
        }

        .skeleton-text {
          height: 12px;
          background: #e0e0e0;
          margin-bottom: 8px;
          border-radius: 4px;
          animation: pulse 1.5s infinite ease-in-out;
        }

        .skeleton-text.short {
          width: 60%;
        }

        .skeleton-text.medium {
          width: 80%;
        }

        .skeleton-text.long {
          width: 90%;
        }

        @keyframes pulse {
          0% {
            opacity: 0.6;
          }
          50% {
            opacity: 1;
          }
          100% {
            opacity: 0.6;
          }
        }

        .product-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
          gap: 20px;
        }
      `}</style>
    </div>
  );
};

function ProductListing() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [mobile, setMobile] = useState(window.innerWidth <= 567 ? true : false);
  const [isLoading, setIsLoading] = useState(true);
  const [particularProduct, setParticularProduct] = useState({});
  const { tokenDetails } = useSelector((state) => state.user);
  const location = useLocation();
  const { category, subcategory, menu, categoryName, subCategoryId, subCategoryName } = useParams();

  const [productData1, setProductData] = useState([]);
  const [categoryImage, setCategoryImage] = useState();
  const { configUrl } = useSelector((state) => state.cart);
  const favorites = useSelector((state) => state.cart.favorites);
  const [buttonHover, setButtonHover] = useState(false)

  console.log("category : ", category);
  console.log("subcategory : ", subcategory);

  useEffect(() => {
    if (category && subcategory) {
      const fetchProducts = async () => {
        try {
          setIsLoading(true);
          const response = await productApi(category, subcategory);
          console.log("productApi : ", response);
          if (response.success) {
            setCategoryImage(response.category_image);
            setProductData(response.data);
          } else {
            setProductData([])
          }
        } catch (error) {
          console.error("API Error:", error);
        } finally {
          setIsLoading(false);
        }
      };
      fetchProducts();
    }
  }, [category, subcategory]);

  const handleFavorite = (product) => {
    const isFavorite = favorites.some((item) => item.id === product.id);
    if (!tokenDetails) {
      toast.error("Please login or Signup");
      return;
    }

    const favoriteProduct = {
      id: product.id,
      menu_id: product.menu_id,
      category_id: product.category_id,
      subcategory_id: product.subcategory_id,
      name: product.name,
      slug: product.slug,
      image: product.image,
      menu_name: product.menu_name,
      menu_slug: product.menu_slug,
      category_name: product.category_name,
      category_slug: product.category_slug,
      subcategory_name: product.subcategory_name,
      subcategory_slug: product.subcategory_slug,
      size: product.size.find((size) => size.size_id),
    };

    console.log("favoriteProduct : ", favoriteProduct);

    if (isFavorite) {
      dispatch(removeFavorite(product.id));
    } else {
      dispatch(addFavorite(favoriteProduct));
    }
  };
  console.log("configUrl : ", configUrl);

  console.log("Product Data:", productData1);
  console.log("Category Name:", categoryName);

  useEffect(() => {
    const loadData = async () => {
      try {
        setProductData(productData1);

        const imageUrls = productData1
          .flatMap((product) => [
            product?.image,
            configUrl + product?.second_image,
          ])
          .filter(Boolean);

        let loadedCount = 0;

        const checkAllImagesLoaded = () => {
          loadedCount++;
          if (loadedCount === imageUrls.length) {
          }
        };

        imageUrls.forEach((url) => {
          const img = new Image();
          img.onload = checkAllImagesLoaded;
          img.onerror = checkAllImagesLoaded;
          img.src = url;
        });

      } catch (error) {
        console.error("Error loading product data:", error);
      }
    };

    loadData();
  }, [productData1, configUrl]);

  const clickProductDetailsHandler = async (name) => {
    navigate(`/detailsPage/${name}`);

  };

  if (isLoading) {
    return <SkeletonLoader />;
  }

  const handle3DButtonClick = async (e) => {
    e.preventDefault();


    if (!tokenDetails) {
      toast.error("Please login or Signup");
      return;
    }
    try {
      console.log("productData1 : ", productData1)
      console.log("menu:", menu);
      console.log("subCategoryId:", subCategoryId);
      console.log("subcategory:", subcategory);
      const subCategoryId1 = subCategoryId
      const formData = new FormData();


      formData.append("subcategoryId", subCategoryId1);

      const result = await get_glbFile(formData);
      console.log("GLB Data:", result);

      if (result.success && result.data) {
        navigate("/3d-product", {
          state: {
            menuSlug: menu,
            subcategorySlug: subcategory,
            glbFile: result.data,
          },
        });
        console.log("details", {
          menuSlug: menu,
          subcategorySlug: subcategory,
          glbFile: result.data,
        })
      } else {
        toast.error("No 3D model available. Please try another product.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong. Please try again later.");
    }
  };

  const handleButtonClick = async (e) => {
    e.preventDefault();

    console.log("subcategoryId : ", subCategoryId)
    if (!tokenDetails) {
      toast.error("Please login or Signup");
      return;
    }
    try {
      const formData = new FormData();

      formData.append("subcategoryId", subCategoryId);

      const result = await get_glbFile(formData);
      console.log("GLB Data:", result);

      if (result.success && result.data) {
        navigate("/3d-product", {
          state: {
            menuSlug: category,
            subcategorySlug: subcategory,
            glbFile: result.data,
          },
        });
      } else {
        toast.error("No 3D model available. Please try another product.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong. Please try again later.");
    }
  };

  return (
    <div>
      <body className="body-container default is-ctl-shield-listing-with-seo-box is-ctl-product_list is-ctl- is-act-">


        <main className="content-main" style={{ backgroundColor: "white", marginTop: "100px", height: "100%" }}>


          {mobile &&
            <div className=""
              style={{ maxHeight: "fit-content", minHeight: "fit-content", height: "100%", overflowY: "auto", display: "flex", flexWrap: "wrap" }}>
              {productData1 && productData1.length > 0 ? (
                productData1?.map((product) => {
                  const isFavorite = favorites.some(
                    (item) => item.id === product.id
                  );
                  const discount = product?.size[0]?.discount_percent;
                  console.log("discount : ", discount);
                  return (
                    <div
                      key={product?.id}
                      className="product-card"
                      style={{ position: "relative", minWidth: "150px", maxWidth: "200px" }}
                    >
                      <div className="product-box">
                        {/* {discount > 0 && (
                                  <div
                                    className="discount-badge pulse-animation"
                                
                                  >
                                    <span style={{ fontSize: "14px" }}>
                                      {discount}% OFF
                                    </span>
                                  </div>
                                )} */}
                        <span
                          onClick={() => handleFavorite(product)}
                          style={{
                            padding: "5px 10px",
                            position: "absolute",
                            top: "10px",
                            right: "10px",
                            borderRadius: "20px",
                            fontSize: "0.9rem",
                            zIndex: "2",


                          }}
                        >
                          {isFavorite ? (
                            <FaHeart color="red" />
                          ) : (
                            <FaRegHeart color="grey" />
                          )}
                        </span>
                        <div
                          className="product-image-wrapper"
                          onClick={(event) => {
                            event.preventDefault();
                            clickProductDetailsHandler(product?.slug);
                          }}
                        >
                          <a
                            href=" "
                            className="product-link1"
                            style={{ height: "100%" }}
                          >
                            <img
                              src={`${product?.image}`}
                              alt={product?.name}
                              className="product-image"
                              style={{
                                width: "140px",
                                maxHeight: "100%",
                                height: "170px",
                              }}
                            />

                          </a>
                        </div>
                        <div className="product-info" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                          <a
                            href={product.link}
                            className=""
                            style={{
                              display: "inline-block",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "97%",
                              verticalAlign: "middle",
                              fontSize: "12px",
                              textDecoration: "none",
                              marginBottom: "5px"
                            }}
                          >
                            <span
                              onClick={(event) => {
                                event.preventDefault();
                                clickProductDetailsHandler(
                                  product?.slug
                                );
                              }}
                            >
                              {product?.name}
                            </span>
                          </a>
                          <p style={{ fontSize: "8px", textAlign: "left" }}>{product?.name}</p>

                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px"
                            }}
                          >
                            <div
                              className="product-price"
                              style={{

                                marginTop: "0px",
                                color: "black",
                                fontSize: "11px"

                              }}
                            >

                              <span>${product?.size[0]?.price}</span>
                            </div>
                            <div
                              className="product-mrp"
                              style={{ fontSize: "9px" }}
                            >
                              <span className="mrp" style={{ color: "#7a7a7aff" }}>
                                ${product?.size[0]?.mrp}
                              </span>
                            </div>
                            <div style={{
                              fontSize: "8px",
                              color: "red",
                              backgroundColor: "pink",
                              borderRadius: "10px",
                              padding: "3px"
                            }}>
                              -{discount}%
                            </div>
                          </div>
                          <div>
                            <p
                              onClick={() => navigate(`/detailsPage/${product.slug}`)}
                              style={{ fontSize: "11px", cursor: "pointer", textAlign: "left", fontWeight: 700, borderBottom: "1px solid black" }}>Shop Now</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="product-grid" style={{ height: "100%", marginLeft: "100px" }}>
                  <h3>No Products Found</h3>

                  {window.innerWidth <= 568 ?
                    <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <p style={{ textAlign: "center", fontSize: "6vw", fontWeight: "bold" }}>
                        COMMING SOON
                      </p></div>
                    :
                    <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <p style={{ textAlign: "center", fontSize: "6vw", fontWeight: "bold" }}>
                        COMMING SOON
                      </p></div>}


                </div>
              )}
            </div>
          }
          <div className="container-main">

            {mobile && <MenFilter
              menu={menu}
              categoryName={categoryName}
              setProductData={setProductData}
              productData={productData1}  // Add this line
            />
            }

            <div className="page-layout">
              <div
                className="page-layout-wrapper"
                //  style={{height:"100%",maxHeight:"1390px",overflow:"hidden" }}
                style={{ height: "100%" }}
              >
                {!mobile && // for desktop view, same component is used for mobile but placed somewhere else
                  <aside className="sidebar1"
                    style={{ width: "20%", height: "100%", msOverflowY: "auto", minHeight: "500px" }}>
                    <MenFilter
                      menu={menu}
                      categoryName={categoryName}
                      setProductData={setProductData}
                      productData={productData1}  // Add this line
                    />
                  </aside>
                }

                {/* height:"90vh" */}
                <section
                  className="main-content"
                  style={{ backgroundColor: "white" }}
                >
                  {/* <button 
                          onClick={handle3DButtonClick}
                          style={{background:buttonHover?"linear-gradient(90deg,black, gray, black, gray)":"linear-gradient(-45deg, black, gray, black,gray)",
                            color:"white",fontSize:"14px",
                            borderRadius:"20px",border:"1px solid white",
                          padding:'12px',fontWeight:500,width:"fit-content",
                          transition:'all 0.2s ease-in-out',
                          transform:buttonHover?`scale(1.1)`:`scale(1)`,
                          backgroundSize:"400% 400%",
                          animation:`gradShift 5s ease infinite`,
                           boxShadow:buttonHover?"0 0 10px 2px gray":"0 0 10px 2px white"
                        }}
                          onMouseEnter={()=>setButtonHover(true)}
                          onMouseLeave={()=>setButtonHover(false)}
                          >
                            Customize Your Dress
                          </button> */}
                  <div className="product-listing">
                    {!mobile && <div className="product-grid" style={{ maxHeight: "fit-content", height: "100%", overflowY: "auto" }}>
                      {productData1 && productData1.length > 0 ? (
                        productData1?.map((product) => {
                          const isFavorite = favorites.some(
                            (item) => item.id === product.id
                          );
                          const discount = product?.size[0]?.discount_percent;
                          console.log("discount : ", discount);
                          return (
                            <div
                              key={product?.id}
                              className="product-card"
                              style={{ position: "relative" }}
                            >
                              <div className="product-box">
                                {/* {discount > 0 && (
                                  <div
                                    className="discount-badge pulse-animation"
                                
                                  >
                                    <span style={{ fontSize: "14px" }}>
                                      {discount}% OFF
                                    </span>
                                  </div>
                                )} */}
                                <span
                                  onClick={() => handleFavorite(product)}
                                  style={{
                                    padding: "5px 10px",
                                    position: "absolute",
                                    top: "10px",
                                    right: "10px",
                                    borderRadius: "20px",
                                    fontSize: "0.9rem",
                                    zIndex: "2",

                                    fontSize: "17px",
                                  }}
                                >
                                  {isFavorite ? (
                                    <FaHeart color="red" />
                                  ) : (
                                    <FaRegHeart color="grey" />
                                  )}
                                </span>
                                <div
                                  className="product-image-wrapper"
                                  onClick={(event) => {
                                    event.preventDefault();
                                    clickProductDetailsHandler(product?.slug);
                                  }}
                                >
                                  <a
                                    href=" "
                                    className="product-link1"
                                    style={{ height: "100%" }}
                                  >
                                    <img
                                      src={`${product?.image}`}
                                      alt={product?.name}
                                      // className="product-image"
                                      style={{
                                        // width: "320px",
                                        // maxHeight: "100%",
                                        // height: "400px",
                                      }}
                                    />
                                    <img
                                      src={`${configUrl}${product?.second_image}`}
                                      alt={product?.name}
                                      className="hover-image"
                                      style={{
                                        width: "400px",
                                        maxHeight: "100%",
                                        height: "400px",
                                      }}
                                    />
                                  </a>
                                </div>
                                <div className="product-info" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "space-between", }}>
                                  <div className="product-info" style={{ overflow: "hidden", maxWidth: "100%" }}>
                                    <a
                                      href={product.link}
                                      className="product-name"
                                      style={{
                                        display: "inline-block",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        maxWidth: "97%",
                                        verticalAlign: "middle",
                                        fontSize: "18px",
                                      }}
                                    >
                                      <span
                                        onClick={(event) => {
                                          event.preventDefault();
                                          clickProductDetailsHandler(
                                            product?.slug
                                          );
                                        }}
                                      >
                                        {product?.name}
                                      </span>
                                    </a>
                                    <p style={{ fontSize: "13px", textAlign: "left", fontWeight: 600, color: "gray" }}>{product?.name}</p>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px"
                                      }}
                                    >
                                      <div
                                        className="product-price"
                                        style={{

                                          marginTop: "0px",
                                          color: "black",
                                          fontSize: "16px"

                                        }}
                                      >

                                        <span>${product?.size[0]?.price}</span>
                                      </div>
                                      <div
                                        className="product-mrp"
                                        style={{ fontSize: "12px" }}
                                      >
                                        <span className="mrp" style={{ color: "#7a7a7aff" }}>
                                          ${product?.size[0]?.mrp}
                                        </span>
                                      </div>
                                      <div style={{
                                        fontSize: "10px",
                                        color: "red",
                                        backgroundColor: "pink",
                                        borderRadius: "10px",
                                        padding: "3px"
                                      }}>
                                        -{discount}%
                                      </div>
                                    </div>
                                  </div>

                                  <p
                                    onClick={() => navigate(`/detailsPage/${product.slug}`)}
                                    style={{ fontSize: "14px", cursor: "pointer", textAlign: "left", fontWeight: 700, borderBottom: "1px solid black", marginBottom: 1 }}>Shop Now</p>

                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="product-grid" style={{ height: "100%", marginLeft: "100px" }}>
                          <h3>No Products Found</h3>

                          {window.innerWidth <= 568 ?
                            <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                              <p style={{ textAlign: "center", fontSize: "6vw", fontWeight: "bold" }}>
                                COMMING SOON
                              </p></div>
                            :
                            <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                              <p style={{ textAlign: "center", fontSize: "6vw", fontWeight: "bold" }}>
                                COMMING SOON
                              </p></div>}


                        </div>
                      )}
                    </div>}




                  </div>




                </section>
              </div>
            </div>
          </div>

        </main>
        <Design />

        <Footer />
      </body>
    </div>
  );
}

export default ProductListing;
